import ComponentTestPage from '@Local/Development/ComponentTestPage';
import CyclePurchaseEffectPreviewPage from '@Local/Development/CyclePurchaseEffectPreviewPage';

/**
 * 開發測試用路由
 * 此路由僅在開發環境中使用，用於測試組件和功能
 *
 * 使用方式：
 * 1. 在開發環境中訪問對應的路徑即可
 * 2. 新增測試組件時，請在此檔案中新增路由配置
 * 3. 測試組件請放在 @Local/Development/ 或 @Local/Test/ 目錄下
 */
const DevelopmentRouter = [
    {
        description: 'UI組件展示',
        menuName: 'UI組件展示',
        static: true,
        exact: true,
        path: '/member/test/components/',
        href: '/member/test/components/',
        as: ComponentTestPage,
        frontKey: 'D999X02',
    },
    {
        description: '循環變更單場景預覽',
        menuName: '循環變更單場景預覽',
        static: true,
        exact: true,
        path: '/member/test/cycle-purchase-effect/',
        href: '/member/test/cycle-purchase-effect/',
        as: CyclePurchaseEffectPreviewPage,
        frontKey: 'D999X03',
    },
];

export default DevelopmentRouter;
